import React from 'react'
import cn from 'classnames'
import styles from './InfoItem.module.scss'

interface IInfoItem {
  title: React.ReactNode | string
  icon: React.ReactNode | string
  description: React.ReactNode | string
  className?: string
}

export const InfoItem: React.FC<IInfoItem> = ({ title, icon, description, className }) => {
  return (
    <div className={cn(styles.InfoItem, className)}>
      <div className={styles.head}>
        {icon}
        <h3>
          {title}
        </h3>
      </div>
      {description && (
        <p dangerouslySetInnerHTML={{ __html: description as string }} />
      )}
    </div>
  )
}